import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { GetSewageSludgeCompostTransportsResponse } from 'src/app/fertilizers/models/sewage-sludge-compost-transport.model';
import { Environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SewageSludgeCompostTransportService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = this.env.ARABLE_JOIN_DATA_REBUILD_DONE
    ? `${this.env.APIM_BASE_URL}/join-data-integration-v2-service/vzc/`
    : `${this.env.API_BASE_URL}/service/arable-join-data-integration/secure/vzc/`;

  public getSewageSludgeCompostTransports(
    kvkNumber: string,
    startDate: string,
    endDate: string,
  ): Observable<GetSewageSludgeCompostTransportsResponse> {
    return this.http.get<GetSewageSludgeCompostTransportsResponse>(this.baseUrl + `${kvkNumber}`, {
      params: {
        startDate,
        endDate,
      },
    });
  }
}
